import $ from 'jquery';
import init from './init';
import pjax, { addMetadataHook } from './pjax';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import footerSection from './sections/footer';
import overlaySection from './sections/overlay';
// import stockistPage from './pages/stockist';
import productsPage from './pages/products';

init();
pjax();

const $html = $('html');
// const $browserMeta = $('meta[name="theme-color"]');

addMetadataHook('htmlClasses', {

	init(value, oldValue) {

		if (Array.isArray(oldValue)) {
			$html.removeClass(oldValue.join(' '));
		}

		if (Array.isArray(value)) {
			$html.addClass(value.join(' '));
		}
	},
});

// addMetadataHook('browserColor', {

// 	init(value) {
// 		$browserMeta.prop('content', value)
// 	},
// });

// modalSection();
overlaySection();
headerSection();
footerSection();

// stockistPage();
productsPage();


// WEBPACK FOOTER //
// ./source/scripts/main.js